module.exports = __webpack_public_path__ + "img/sydney.578aba75.svg";